import { NgModule } from "@angular/core";
import { DayPilotModule } from "daypilot-pro-angular";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { PlaneraColorExplanationPopoverComponent } from "../planera-color-explanation-popover/planera-color-explanation-popover.component";
import { ArbetsorderPlaneringSchedulerComponent } from "./arbetsorder-planering-scheduler.component";
import { ArbetsorderSchedulerPopoverNgxComponent } from "./arbetsorder-scheduler-popover-ngx/arbetsorder-scheduler-popover-ngx/arbetsorder-scheduler-popover-ngx.component";
import { ArbetsorderStatusIkonerComponent } from "./arbetsorder-status-ikoner/arbetsorder-status-ikoner.component";
import { ArbetsorderPlaneringSchedulerService } from "./services/arbetsorder-planering-scheduler.service";
import { ArbetsorderPlaneringSchedulerSettingsComponent } from "./settings/arbetsorder-planering-scheduler-settings.component";

@NgModule({
    imports: [
        DayPilotModule,
        RaskCommonModule,
        ArbetsorderPlaneringSchedulerComponent,
        ArbetsorderPlaneringSchedulerSettingsComponent,
        ArbetsorderSchedulerPopoverNgxComponent,
        ArbetsorderStatusIkonerComponent,
        PlaneraColorExplanationPopoverComponent
    ],
    providers: [ArbetsorderPlaneringSchedulerService],
    exports: [
        ArbetsorderPlaneringSchedulerComponent,
        ArbetsorderStatusIkonerComponent
    ]
})

export class ArbetsorderPlaneringSchedulerModule { }
